// src/v3/account/phone.tsx
import SvgIcon from "@mui/material/SvgIcon";
import { jsx } from "react/jsx-runtime";
var PhoneIcon = (props) => /* @__PURE__ */ jsx(SvgIcon, { "data-testid": "PhoneIcon", viewBox: "0 0 24 24", ...props, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor",
    d: "m20.477 15.235-4.416-1.979-.012-.005a1.5 1.5 0 0 0-1.493.184l-2.282 1.945c-1.445-.702-2.938-2.184-3.64-3.61l1.948-2.317a1.5 1.5 0 0 0 .177-1.484v-.011L8.774 3.534a1.5 1.5 0 0 0-1.558-.893A5.274 5.274 0 0 0 2.63 7.88c0 7.444 6.056 13.5 13.5 13.5a5.274 5.274 0 0 0 5.239-4.586 1.5 1.5 0 0 0-.892-1.559ZM16.13 19.88a12.014 12.014 0 0 1-12-12A3.769 3.769 0 0 1 7.4 4.13v.011l1.968 4.406-1.938 2.32a.574.574 0 0 0-.053.072 1.5 1.5 0 0 0-.094 1.472c.85 1.737 2.6 3.474 4.356 4.323a1.5 1.5 0 0 0 1.476-.107.804.804 0 0 0 .07-.053l2.278-1.944 4.407 1.973h.01a3.77 3.77 0 0 1-3.75 3.277Z"
  }
) });

export {
  PhoneIcon
};
